import { render, staticRenderFns } from "./InformeRevision.vue?vue&type=template&id=3d736bff&scoped=true&"
import script from "./InformeRevision.vue?vue&type=script&lang=js&"
export * from "./InformeRevision.vue?vue&type=script&lang=js&"
import style0 from "./InformeRevision.vue?vue&type=style&index=0&id=3d736bff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d736bff",
  null
  
)

export default component.exports